import { render, staticRenderFns } from "./AccountJourney.vue?vue&type=template&id=175dd77c&"
import script from "./AccountJourney.vue?vue&type=script&lang=js&"
export * from "./AccountJourney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports